import { http } from "../client";
export * from "./get-all";
export * from "./get-detail";
export * from "./delete";
export * from "./copy";
export * from "./create";
export * from "./update";
export * from "./sync";
var URL = "playlists";
var publish = function (_a) {
    var id = _a.id, publish = _a.publish;
    var url = URL + "/" + id + "/" + (publish ? "publish" : "unpublish");
    return http.api.get(url);
};
export var playlistsApi = {
    publish: publish,
};
